import { useEffect, useRef } from "react";
import { API_BASE } from "../api";

const INACTIVITY_MS = 30 * 60 * 1000;
const ACTIVITY_EVENTS = ["mousemove", "mousedown", "keydown", "touchstart", "scroll", "click"];

function doLogout() {
  localStorage.removeItem("token");
  window.location.replace("/login");
}

export default function AuthGate({ children }) {
  const timerRef = useRef(null);

  const resetTimer = () => {
    clearTimeout(timerRef.current);
    timerRef.current = setTimeout(doLogout, INACTIVITY_MS);
  };

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) { doLogout(); return; }

    // Verificare în background — nu blochează randarea
    // Logout DOAR la 401 (token invalid/expirat), nu la erori temporare (429, 5xx, network)
    fetch(`${API_BASE}/auth/me`, {
      headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
    })
      .then((res) => {
        if (res.status === 401) {
          localStorage.removeItem("token");
          doLogout();
        } else {
          resetTimer();
          ACTIVITY_EVENTS.forEach(ev => window.addEventListener(ev, resetTimer, { passive: true }));
        }
      })
      .catch(() => {
        // Eroare de rețea sau server temporar indisponibil — rămânem logați
        resetTimer();
        ACTIVITY_EVENTS.forEach(ev => window.addEventListener(ev, resetTimer, { passive: true }));
      });

    const handlePageShow = (e) => {
      if (e.persisted) {
        const t = localStorage.getItem("token");
        if (!t) doLogout();
        else resetTimer();
      }
    };
    window.addEventListener("pageshow", handlePageShow);

    return () => {
      clearTimeout(timerRef.current);
      ACTIVITY_EVENTS.forEach(ev => window.removeEventListener(ev, resetTimer));
      window.removeEventListener("pageshow", handlePageShow);
    };
  }, []);

  // Dacă nu e token deloc, nu randăm nimic (redirect se face în useEffect)
  if (!localStorage.getItem("token")) return null;

  // Token există → afișăm imediat, verificarea e în background
  return children;
}
